(function(){
  var GIFT_VARIANT = 54961393271126;
  var HELPERS = ['/products/saker-frakt-ingar','/products/fraktgaranti'];

  var CART_SVG = '<svg class="sv-cart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">'
    + '<path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" fill="currentColor"/>'
    + '</svg>';

  function icon(path){
    return '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' + path + '</svg>';
  }
  var ICON_TRUCK = '<path d="M3 6.5h10v9H3v-9Zm10 3h3.6l2.4 3v3h-6v-6Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="7" cy="17.5" r="1.6" stroke="currentColor" stroke-width="1.6"/><circle cx="16.5" cy="17.5" r="1.6" stroke="currentColor" stroke-width="1.6"/>';
  var ICON_SHIELD = '<path d="M12 3.2 5.5 5.8v5.4c0 4 2.8 7.5 6.5 8.6 3.7-1.1 6.5-4.6 6.5-8.6V5.8L12 3.2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="m9.2 11.9 2 2 3.6-3.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>';

  /* ---------- varukorgsikon ---------- */
  function paintCart(){
    var a = document.getElementById('cart-icon-bubble');
    if(!a || a.querySelector('.sv-cart')) return;
    var old = a.querySelector('svg');
    if(old){ var w = document.createElement('span'); w.innerHTML = CART_SVG; old.replaceWith(w.firstChild); }
  }

  /* ---------- menydrawer ---------- */
  function buildDrawer(){
    var inner = document.querySelector('.menu-drawer__inner-container');
    if(!inner || inner.querySelector('.sv-md')) return;
    var navWrap = inner.querySelector('.menu-drawer__navigation-container');
    if(!navWrap) return;
    var cfg = window.SV_MENU || {};
    var links = [];
    inner.querySelectorAll('.menu-drawer__menu > li > a, .menu-drawer__menu > li > summary').forEach(function(el){
      links.push({ label:(el.textContent||'').trim(), href: el.getAttribute('href')||'#', active: el.classList.contains('menu-drawer__menu-item--active') });
    });
    var nav = inner.querySelector('.menu-drawer__navigation');
    if(nav) nav.classList.add('sv-md-hide');
    var box = document.createElement('div');
    box.className = 'sv-md';
    var html = '<div class="sv-md-lbl">Handla</div>';
    html += '<div class="sv-md-trust">'
         +  '<div>' + icon(ICON_TRUCK) + '<span>' + (cfg.trust1 || 'Fri frakt över 499 kr') + '</span></div>'
         +  '<div>' + icon(ICON_SHIELD) + '<span>' + (cfg.trust2 || '30 dagars öppet köp') + '</span></div>'
         +  '</div>';
    var prods = cfg.products || [];
    if(prods.length){
      html += '<div class="sv-md-cards">';
      prods.forEach(function(p){
        html += '<a class="sv-md-card" href="' + p.url + '">'
             +  (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="54" height="54">' : '')
             +  '<span>' + p.title + '</span></a>';
      });
      html += '</div>';
    }
    html += '<a class="sv-md-all" href="' + (cfg.allUrl || '/collections/all') + '">Alla produkter</a>';
    html += '<hr class="sv-md-hr">';
    var split = Math.min(3, links.length);
    function col(title, arr){
      var s = '<div><div class="sv-md-lbl" style="margin-top:0">' + title + '</div><ul>';
      arr.forEach(function(l){ s += '<li><a class="' + (l.active ? 'is-active' : '') + '" href="' + l.href + '">' + l.label + '</a></li>'; });
      return s + '</ul></div>';
    }
    html += '<div class="sv-md-cols">' + col('Handla', links.slice(0, split)) + col('Hjälp', links.slice(split)) + '</div>';
    box.innerHTML = html;
    navWrap.parentNode.insertBefore(box, navWrap);
  }

  /* ---------- dölj hjälpprodukter i listningar ---------- */
  function hideHelpers(){
    var listing = /\/search|\/collections/.test(location.pathname);
    if(!listing) return;
    HELPERS.forEach(function(h){
      document.querySelectorAll('a[href*="' + h + '"]').forEach(function(a){
        var card = a.closest('li, .card-wrapper, .grid__item, .card, .product-card');
        if(card) card.classList.add('sv-hidden-card');
      });
    });
    document.querySelectorAll('[class*="badge"], [class*="Badge"]').forEach(function(b){
      if(/100\s*%/.test(b.textContent||'')) b.classList.add('sv-hidden-card');
    });
  }

  /* ---------- säker frakt: ingår redan ---------- */
  var freeState = null, lastCheck = 0;
  function paintAddon(){
    var box = document.querySelector('.aurel-addons .aurel-ship');
    if(!box) return;
    if(freeState === true){
      if(!box.classList.contains('sv-inc')){
        box.classList.add('sv-inc');
        var i = box.querySelector('i');
        if(i && !i.querySelector('s')) i.innerHTML = '<s>59 kr</s>Ingår';
      }
    } else if(freeState === false){
      box.classList.remove('sv-inc');
    }
  }
  function checkCart(){
    if(!document.querySelector('.aurel-addons')) return;
    var now = (window.performance && performance.now) ? performance.now() : 0;
    if(now - lastCheck < 1500) { paintAddon(); return; }
    lastCheck = now;
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        var _q=0,_fl=0;(c.items||[]).forEach(function(it,i){ if(it.handle==="v-boost") _q+=it.quantity; if(it.handle==="fraktgaranti") _fl=i+1; }); freeState = _q>=4 || (c.items||[]).some(function(it){ return it.variant_id === GIFT_VARIANT; }); if(freeState && _fl){ fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({line:_fl,quantity:0})}).then(function(){ window.location.href="/cart"; }); return; }
        paintAddon();
      }).catch(function(){});
  }

  /* ---------- storleksguide-länk på produktsidan ---------- */
  function sizeLink(){
    var lbls = document.querySelectorAll('.pdp-optlbl');
    if(lbls.length < 2 || lbls[1].querySelector('.sv-sizelink')) return;
    var a = document.createElement('a');
    a.className = 'sv-sizelink';
    a.href = '/pages/storleksguide';
    a.textContent = 'Storleksguide';
    lbls[1].appendChild(a);
  }

  var queued = false;
  function run(){ queued = false; paintCart(); buildDrawer(); hideHelpers(); sizeLink(); checkCart(); }
  function schedule(){ if(queued) return; queued = true; requestAnimationFrame(run); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', run); } else { run(); }
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {childList:true, subtree:true});
})();
